import { useState } from 'react'
import {
  Button,
  Divider,
  Flex,
  Form,
  Image,
  Input,
  Modal,
  Typography,
} from 'antd'
import { Task } from 'src/pages/goldenMay2026/tasks/types'
import { moderationTaskFx } from 'src/pages/goldenMay2026/tasks/model'

type Props = {
  isVisible: boolean
  onClose: () => void
  data: Task
}

export const ClientTaskModal = ({ isVisible, onClose, data }: Props) => {
  const [isDeclineReason, setIsDeclineReason] = useState<boolean>(false)
  const [form] = Form.useForm()
  const { Item } = Form
  const { Text } = Typography
  const { TextArea } = Input

  const handleApprove = async () => {
    try {
      await moderationTaskFx({
        url: `/promo/golden_may_2026/participant_task/${data.id}`,
        body: {
          status: 'accepted',
          declineReason: '',
        },
      })
      form.resetFields()
      onClose()
    } catch (error) {}
  }

  const handleReject = async () => {
    if (!isDeclineReason) {
      setIsDeclineReason(true)
      return
    }
    try {
      const values = await form.validateFields()
      await moderationTaskFx({
        url: `/promo/golden_may_2026/participant_task/${data.id}`,
        body: {
          status: 'declined',
          declineReason: values.declineReason,
        },
      })
      form.resetFields()
      onClose()
    } catch {}
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Task</div>}
      centered
      wrapClassName="ant_modal"
      width={700}
      maskClosable={false}
      open={isVisible}
      destroyOnHidden
      onCancel={() => {
        onClose()
        form.resetFields()
        setIsDeclineReason(false)
      }}
      footer={
        <Flex gap={8} justify="flex-end">
          <Button color="green" variant="solid" onClick={handleApprove}>
            Approve
          </Button>
          <Button color="volcano" variant="solid" onClick={handleReject}>
            Reject
          </Button>
        </Flex>
      }
    >
      <Divider />

      <Flex vertical>
        {data.checkType === 'image' ? (
          <Image
            className="mb-3"
            width={250}
            src={data.imgUrl}
            preview={false}
          />
        ) : (
          <a className="mb-3" href={data.checkValue} target="_blank">
            {data.checkValue}
          </a>
        )}
        {isDeclineReason && (
          <Form form={form} layout="vertical">
            <Item
              required={false}
              name="declineReason"
              label={
                <Text style={{ fontSize: 16 }} strong>
                  Decline reason
                </Text>
              }
              rules={[
                {
                  required: true,
                  message: 'Required field',
                },
              ]}
            >
              <TextArea rows={6} autoFocus placeholder="reason" />
            </Item>
          </Form>
        )}
      </Flex>
    </Modal>
  )
}
